import { usePathname as useNextPathname } from "i18n/routing";

const HCLP_PATHS = [
  "/gowheredollarswont",
  "/gowheredollarswont/sg",
  "/gowherepoundswont",
  "/gowhereeuroswont"
];

/**
 * Custom hook to check various pathname conditions
 * @returns object with various pathname checks
 */
export const usePathnameChecks = (): {
  isGoogleSearchPath: boolean;
  isHighConversionPath: boolean;
  isPartnerPath: boolean;
} => {
  const pathname = useNextPathname();

  return {
    isGoogleSearchPath: pathname?.startsWith("/lp/exchangeapp") ?? false,
    isHighConversionPath: HCLP_PATHS.includes(pathname) ?? false,
    isPartnerPath: pathname?.startsWith("/partners") ?? false
    // Add more pathname checks here as needed
  };
};
